import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {
  value: string;
  textStyle?: 'headingTitle' | 'textBody';
  title?: string;
  subtitle?: string;
};

export const TextDisplay: React.FC<IProps> = ({
  value,
  textStyle,
  title,
  subtitle
}) => {
  return (
    <Flex flexDirection={'column'}>
      {title && (
        <Flex flexDirection={'column'}>
          <Flex flexDirection={'row'} gap={2}>
            <Text textStyle="headingItem">{title}</Text>
          </Flex>
        </Flex>
      )}
      <Flex flexDirection="column" gap={2}>
        <Text textStyle={textStyle ?? 'textBody'}>{value}</Text>
        {subtitle && (
          <Text textStyle={textStyle ?? 'textBody'}>{subtitle}</Text>
        )}
      </Flex>
    </Flex>
  );
};
